/**
 * Allows JSON object or array unless validateForObject is true.
 */
export const isValidJSON = (json: string, validateForObject: boolean = false): boolean => {
  if (typeof json !== 'string') return false;

  const value = json.trim();
  if (validateForObject) {
    const isObject = value[0] === '{' && value[value.length - 1] === '}';
    // must be object
    if (!isObject) return false;
  }

  // empty string is not object and not json valid
  if (value === '') return false;

  try {
    JSON.parse(value);
    return true;
  } catch {
    return false;
  }
};
